module.exports = __webpack_public_path__ + "img/latest-VB-Logo.ebb87faa.svg";